export default "__VITE_ASSET__BzvmEpMV__"